import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { RouteGuardService } from './service/route-guard.service';
import { View } from '../layout/model/interfaces/view.interface';

@Injectable({ providedIn: 'root' })
export class ProcessDetailsViewGuard implements CanActivate {
  private routeGuardService = inject(RouteGuardService);


  async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
    const view = this.getView(route);
    if (view) {
      return await this.routeGuardService.handleRoute(view, route);
    }
    return true;
  }

  getView(route?: ActivatedRouteSnapshot): View {
    const uuid = route?.paramMap?.get('uuid') || 'unknown';
    return {
      route: `workflow2/${uuid}`,  // Changed to match actual Angular route (without 's')
      iframeUrl: `workflow2/${uuid}`,
    };
  }
}
